import { PageHeader } from '@hvac/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { sessionQuery } from '../../shared/api/queries.js';
import { ConnectionsCard } from '../connections/connections-card.js';
import { BillingCard } from './billing-card.js';
import { DeleteBusinessCard } from './delete-business-card.js';
import { ExportDataCard } from './export-data-card.js';
import { InvoicingSettingsCard } from './invoicing-settings-card.js';
import { PeopleCard } from './people-card.js';

/**
 * Settings: what the business is connected to, and whether it stays.
 */
export function SettingsPage() {
  const { data: session } = useSuspenseQuery(sessionQuery());
  const organizationId = session.activeOrganizationId ?? '';
  const membership = session.organizations.find(
    (entry) => entry.organization.id === organizationId,
  );
  const canManage = membership?.permissions.includes('organization:manage') ?? false;

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        eyebrow="Business"
        title="Settings"
        description="What this business is connected to, and what happens to its data."
      />
      {membership === undefined ? null : (
        <PeopleCard
          organizationId={organizationId}
          myRole={membership.role}
          canInvite={membership.permissions.includes('invitation:create')}
        />
      )}
      <InvoicingSettingsCard
        organizationId={organizationId}
        canEdit={membership?.permissions.includes('organization:update') ?? false}
      />
      <ConnectionsCard organizationId={organizationId} />
      <BillingCard />
      {canManage ? <ExportDataCard organizationId={organizationId} /> : null}
      <DeleteBusinessCard
        organizationId={organizationId}
        organizationName={membership?.organization.name ?? ''}
        isOwner={membership?.role === 'owner'}
      />
    </div>
  );
}
